import { setAlert } from '../alert';
import {
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_VOLUMES,
    API_POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY,
    API_GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY,
    API_POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE,
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE,
    API_GET_TIGERCAT_BURNS_FEEDSTOCK_PROCESSING_FUEL,
    API_POST_TIGERCAT_BURNS_POST_PROPANE_REFILL,
    API_GET_TIGERCAT_BURNS_GET_PROPANE_REFILL,
    API_POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT,
    API_GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT,
    API_POST_TIGERCAT_BURNS_ADD_BASE_CALLER,
    API_POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION,
    API_GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG,
    API_GET_TIGERCAT_BURNS_GET_BASE_CALLERS,
    API_GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS,
    API_POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT,
    API_POST_TIGERCAT_BURNS_POST_BIOCHAR_MC,
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_MC,
    API_POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT,
    API_GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT,
    API_TELEMATICS_ACTIVITY_DATA,
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_COLLECTION,
    API_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT,
    API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES,
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES,
    API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS,
    API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS,
    API_GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT,
    API_POST_FEEDSTOCK_MOISTURE_CONTENT,
    API_GET_FEEDSTOCK_MOISTURE_CONTENT,
    API_GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES
} from './constants/tigercat-constants';

import {
    GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_SUCCESS,
    GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_FAIL,
    //
    GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_SUCCESS,
    GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_FAILURE,
    // 
    POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_SUCCESS,
    POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_FAILURE,
    //    
    POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_FAIL,
    //
    POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_SUCCESS,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_FAIL,
    //
    POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_SUCCESS,
    POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_SUCCESS,
    GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_FAIL,
    //
    POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_SUCCESS,
    POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_FAIL,
    //
    POST_TIGERCAT_BURNS_ADD_BASE_CALLER_SUCCESS,
    POST_TIGERCAT_BURNS_ADD_BASE_CALLER_FAIL,
    POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_SUCCESS,
    POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_FAIL,
    GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_SUCCESS,
    GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_FAIL,
    //
    GET_TIGERCAT_BURNS_GET_BASE_CALLERS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BASE_CALLERS_FAIL,
    //
    POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_FAIL,
    POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_SUCCESS,
    POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_FAIL,
    GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_FAIL,
    API_POST_TELEMATICS_ACTIVITY_DATA_SUCCESS,
    API_POST_TELEMATICS_ACTIVITY_DATA_FAIL,
    API_GET_TELEMATICS_ACTIVITY_DATA_SUCCESS,
    API_GET_TELEMATICS_ACTIVITY_DATA_FAIL,
    // 
    GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_SUCCESS,
    GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_FAIL,

    API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_SUCCESS,
    API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_FAIL,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_SUCCESS,
    GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_FAIL,

    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,


    POST_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
    POST_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
    GET_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
    GET_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
    GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_SUCCESS,
    GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_FAIL
} from './types/tigercat-types';
import api from '../../util/api';

const config = {
    headers: {
        'Content-Type': 'application/json'
    },
};

const formDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}

export const getBiocharVolumes = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_VOLUMES + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharCollection = (carRppbProjectId, type, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_COLLECTION + `/${carRppbProjectId}/${type}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharMassBags = (carRppbProjectId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS + `/${carRppbProjectId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_FAILURE,
            payload: err.response.data.detail,
        });
    }
};

export const postBiocharMassBagMoistureContent = (biocharMassBagData, carRppbProjectId) => async dispatch => {
    try {
        // console.log(biocharMassBagData[0].get('mbId'), 'show me data')
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT + `/${carRppbProjectId}`,
            biocharMassBagData,
            config
        );
        dispatch({
            type: POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_FAILURE,
            payload: err.response.data.detail,
        });
    }
};

export const postBulkFuelDelivery = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBulkFuelDelivery = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postBiocharProductionFuelUse = (carRppbProjectId, fuelUseData) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE + `/${carRppbProjectId}`,
            fuelUseData,
            config
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharProductionFuelUse = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFeedstockProcessingFuel = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_FEEDSTOCK_PROCESSING_FUEL + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postPropaneRefill = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_PROPANE_REFILL + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getPropaneRefill = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_PROPANE_REFILL + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_FAIL,
            payload: err.response.data.detail,
        });
    }
};



export const postBiocharMc = (carRppbProjectId, formDataArray, type) => async dispatch => {
    try {
        // const formData = new FormData();
        // formDataArray.forEach((formDataItem, index) => {
        //     for (const [key, value] of formDataItem.entries()) {
        //         formData.append(`data[${index}][${key}]`, value);
        //     }
        // });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_BIOCHAR_MC + `/${carRppbProjectId}/${type}`,
            formDataArray,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharMc = (carRppbProjectId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_MC + `/${carRppbProjectId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const postFeedstockTransport = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFeedstockTransport = (carRppbProjectId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT + `/${carRppbProjectId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const addBaseCaller = (carRppbProjectId, callerData) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_POST_TIGERCAT_BURNS_ADD_BASE_CALLER}/${carRppbProjectId}`,
            callerData,
            config
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_ADD_BASE_CALLER_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_ADD_BASE_CALLER_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBaseCallers = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_GET_TIGERCAT_BURNS_GET_BASE_CALLERS}/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BASE_CALLERS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BASE_CALLERS_FAIL,
            payload: err.response.data.detail,
        });
    }
}

export const addCallSubmission = (carRppbProjectId, callSubmissionData) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION}/${carRppbProjectId}`,
            callSubmissionData,
            config
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getCallSubmissionLog = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG}/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postEquipmentTransport = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getEquipmentTransport = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postTelematicsActivityData = (carRppbProjectId, equipmentId, telematicsActivityData, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().post(
            `${process.env.REACT_APP_API_URL}${API_TELEMATICS_ACTIVITY_DATA}/${carRppbProjectId}/${equipmentId}/${rowsPerPage}/${currentPage}`,
            telematicsActivityData,
            formDataConfig
        );
        dispatch({
            type: API_POST_TELEMATICS_ACTIVITY_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_POST_TELEMATICS_ACTIVITY_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getTelematicsActivityData = (carRppbProjectId, userCompanyId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_TELEMATICS_ACTIVITY_DATA}/${carRppbProjectId}/${userCompanyId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: API_GET_TELEMATICS_ACTIVITY_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_GET_TELEMATICS_ACTIVITY_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getTelematicsActivityDataForEquipment = (carRppbProjectId, equipmentId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            `${process.env.REACT_APP_API_URL}${API_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT}/${carRppbProjectId}/${equipmentId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const postBiocharLabSamples = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharLabSamples = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_FAIL,
            payload: err.response.data.detail,
        });
    }
};


export const downloadDocument = (carRppbProjectId, type) => async dispatch => {
    try {
        const response = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT + `/${carRppbProjectId}/${type}`,
            { responseType: 'blob' }
        );

        dispatch({
            type: GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_SUCCESS,
            payload: response.data,
        });
        dispatch(setAlert('Document downloaded successfully', 'success'));

        // Return the response so the component can handle the file download
        return response;
    } catch (err) {
        dispatch(setAlert(err.response?.data?.detail || 'Failed to download Document', 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_FAIL,
            payload: err.response?.data?.detail || 'Error occurred',
        });
        throw err; // Re-throw the error so the component can handle it
    }
};

export const postBiocharLabSamplesContaminants = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getBiocharLabSamplesContaminants = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const postFeedstockMoistureContent = (carRppbProjectId, formDataArray) => async dispatch => {
    try {
        const formData = new FormData();
        formDataArray.forEach((formDataItem, index) => {
            for (const [key, value] of formDataItem.entries()) {
                formData.append(`data[${index}][${key}]`, value);
            }
        });

        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_FEEDSTOCK_MOISTURE_CONTENT + `/${carRppbProjectId}`,
            formData,
            formDataConfig
        );
        dispatch({
            type: POST_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFeedstockMoistureContent = (carRppbProjectId, rowsPerPage, currentPage) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FEEDSTOCK_MOISTURE_CONTENT + `/${carRppbProjectId}/${rowsPerPage}/${currentPage}`,
            config
        );
        dispatch({
            type: GET_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getFeedstockMoistureContentAverages = (carRppbProjectId) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES + `/${carRppbProjectId}`,
            config
        );
        dispatch({
            type: GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_FAIL,
            payload: err.response.data.detail,
        });
    }
};